const doisDigitos = (valor) => String(valor).padStart(2, "0");

export default function formatarDuracao(minutos) {
  const segundos = Math.round(Math.max(Number(minutos) || 0, 0) * 60);
  if (segundos === 0) return "0min";
  if (segundos < 60) return `${segundos}s`;
  if (segundos < 3600) {
    const inteiros = Math.floor(segundos / 60);
    const resto = segundos % 60;
    return resto ? `${inteiros}min${doisDigitos(resto)}s` : `${inteiros}min`;
  }
  const totalDeMinutos = Math.round(segundos / 60);
  const horas = Math.floor(totalDeMinutos / 60).toLocaleString("pt-BR");
  const resto = totalDeMinutos % 60;
  return resto ? `${horas}h${doisDigitos(resto)}min` : `${horas}h`;
}
